import { Layout } from "antd"
import { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { renderRoutes } from "react-router-config"

import PageClock from "@/components/sc/PageClock"
import ImgMainBg from "@/assets/img/main-bg.png"
import api from "@/net/api"
import { sysuserInfoSlice } from "@/store"
import {Base64} from '@/util/base64'

const { Header, Content } = Layout

import "./index.less"

export default function Main({ location, history, route }) {
	const dispatch = useDispatch()
	const user = useSelector(state => state.sysuserInfo || {})
	const [isOpenScreen,setIsOpenScreen] = useState(false)
	const [sId,setSId] = useState(null)
	const timerId = useRef(null)
	// var timerInter;
	useEffect(() => {
		let params = location.search.split('?id=')[1]
		let rid = Base64.decode(params)
		setSId(params)
		// 获取学校/组织信息
		function getSysOrgInfo() {
			api.display_info({rid}).then(d => {
				setIsOpenScreen(true)
				dispatch(sysuserInfoSlice.actions.save(d))
			}).catch(err=>{
				setIsOpenScreen(false)
			})
		}
		if(location.pathname=='/main/home'||location.pathname=='/main/dingzhi-home'){
			getSysOrgInfo()
		}
		return () => {
      clearInterval(timerId.current)
    }
	}, [])

	return <div className="pages_main">
		{isOpenScreen && <>
		<img className="main-bg" src={ImgMainBg} alt="logo" />
		<Layout className="main-layout">
			<Header className="layout-header">
				<div className="header-left">
					<img className="left-img" src={user.logoUrl} alt="logo" />
					<div className="left-name">{user.buyerOrgName}校联云智慧管理平台</div>
				</div>
				<PageClock />
			</Header>

			<Content className="layout-content" onClick={e=>{
				// clearInterval(timerId.current)
				// console.log('触发了',timerId.current)
				// timerId.current = setInterval(()=>{
				// 	if(history.location.pathname!='/main/home'){
				// 		clearInterval(timerId.current)
				// 		history.push('/main/home?id='+sId)
				// 	}else{
				// 		clearInterval(timerId.current)
				// 		window.location.reload()
				// 	}
				// },5*60 * 1000)
			}}>{renderRoutes(route.routes)}</Content>
		</Layout></>}
	</div>
}
